<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/messages/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ساخت پیام جدید</v-card-title>
      <v-card-text>
        <!--        FILTERS-->
        <v-row>
          <v-col cols="2">
            <v-select label="گروه را انتخاب کنید"
                      :items="[{value:'students',text:'هنرجویان'},{value:'instructors',text:'مربیان'}]"
                      item-text="text" item-value="value"
                      color="black" v-model="selectedGroup" @change="clearStudentsAndInstructors()">
            </v-select>
          </v-col>
          <v-col>
            <v-select multiple label="دوره را انتخاب کنید" :items="courses"
                      item-text="title" item-value="id"
                      color="black" v-model="selectedCourses" @change="getClasses()">
            </v-select>
          </v-col>
          <v-col>
            <v-autocomplete multiple label="کلاس را انتخاب کنید" :items="classes"
                            item-text="title" item-value="id"
                            color="black" v-model="selectedClasses"
                            @change="selectedGroup === 'instructors' ?  getInstructors() : getStudents()">
            </v-autocomplete>
          </v-col>
          <v-col v-if="selectedGroup === 'students'">
            <v-autocomplete multiple label="هنرجویان را فیلتر کنید" :items="students"
                            item-text="name" item-value="id"
                            color="black" v-model="selectedStudents">
            </v-autocomplete>
          </v-col>
          <v-col v-if="selectedGroup === 'instructors'">
            <v-autocomplete multiple label="مربیان را فیلتر کنید" :items="instructors"
                            item-text="name" item-value="id"
                            color="black" v-model="selectedInstructors">
            </v-autocomplete>
          </v-col>
        </v-row>
        <!--        OTHER FIELDS-->
        <v-row>
          <v-col cols="3">
            <v-text-field color="black" v-model="message.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-checkbox
                label="پیام فایل ضمیمه دارد؟"
                v-model="has_attachment"
                color="black"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="2">
            <vue-persian-datetime-picker color="black" v-model="message.expire_at"
                                         type="datetime"
                                         custom-input="#expire_at"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ و زمان انقضا پیام" v-model="message.expire_at" id="expire_at"
                          color="black">
            </v-text-field>
          </v-col>
          <v-col v-if="has_attachment" cols="2">
            <v-select
                label="نوع فایل پیام را مشخص کنید"
                :items="attachment_types"
                v-model="message.attachment_type"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="4" v-if="has_attachment">
            <v-text-field label="فایل"
                          @click="fileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="message.url"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="message.content" label="محتوای پیام"></v-textarea>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="fileDialog" max-width="50vw">
      <drag-and-drop module="notification" ref="file-uploader" @closeUploadFileDialog="fileDialog = false"
                     @changeFile="message.url = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "MessageCreate",
  components: {DragAndDrop, VuePersianDatetimePicker},
  data() {
    return {
      fileDialog: false,
      attachment_types: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
        {value: 'zip', text: 'فایل فشرده'},
      ],
      courses: [],
      classes: [],
      students: [],
      instructors: [],
      selectedCourses: [],
      selectedClasses: [],
      selectedStudents: [],
      selectedInstructors: [],
      selectedGroup: 'students',
      has_attachment: false,
      message: {
        title: null,
        content: null,
        instructor_ids: null,
        student_ids: null,
        url: null,
        expire_at: null,
        attachment_type: null,
      }
    }
  },
  mounted() {
    this.getCourses()
  },
  methods: {
    store() {
      this.message.instructor_ids = this.selectedInstructors
      this.message.student_ids = this.selectedStudents
      window.axios.post('message/crud/create', this.message).then(() => {
        this.openSnackbar("پیام جدید با موفقیت ساخته شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.message = {
        title: null,
        content: null,
        instructor_ids: null,
        student_ids: null,
        url: null,
        attachment_type: null,
      }
    },
    clearStudentsAndInstructors() {
      this.selectedCourses = [];
      this.selectedClasses = [];
      this.selectedInstructors = [];
      this.selectedStudents = [];
    },
    getCourses() {
      let url = '/course/crud/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.courses = res.data.data.data
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getClasses() {
      window.axios.post('/class/crud/filter?per_page=1000', {
        course_ids: this.selectedCourses
      }).then((res) => {
        this.classes = res.data.data.data
        this.selectedClasses = []
        this.classes.forEach((item) => {
          this.$set(this.selectedClasses, this.selectedClasses.length, item.id)
        })
        if (this.selectedGroup === 'instructors') {
          this.getInstructors()
        } else {
          this.getStudents()
        }
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getInstructors() {
      window.axios.post('/admin/instructor/filter?per_page=1000', {
        course_ids: this.selectedCourses,
        class_ids: this.selectedClasses
      }).then((res) => {
        this.instructors = res.data.data.data
        this.selectedStudents = []
        this.selectedInstructors = []
        this.instructors.forEach((item) => {
          this.$set(this.selectedInstructors, this.selectedInstructors.length, item.id)
        })
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getStudents() {
      window.axios.post('/admin/student/filter?per_page=1000', {
        course_ids: this.selectedCourses,
        class_ids: this.selectedClasses
      }).then((res) => {
        this.students = res.data.data.data
        this.selectedStudents = []
        this.selectedInstructors = []
        this.students.forEach((item) => {
          this.$set(this.selectedStudents, this.selectedStudents.length, item.id)
        })
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>